import { StepStatus } from '../types';

export const getStepStatus = (
  index: number,
  currentStep: number
): StepStatus => {
  if (index < currentStep) return 'previous';
  if (index === currentStep) return 'current';
  return 'future';
};
